import * as React from "react";
import { twMerge } from "tailwind-merge";
import InputContainer from "./InputContainer";
import PickerContainer from "./PickerContainer";

export const FILTER_TEXT_FIELD_INPUT_CLASSNAME =
  "p-0 w-full bg-transparent focus:ring-0 border-none outline-none text-text-surface font-sans text-sm";

export type TextFieldClassNames = {
  root?: string;
  label?: string;
  container?: string;
  error?: string;
  input?: string;
};

export type TextFieldProps = {
  label?: string;
  errorMessage?: string;
  classNames?: TextFieldClassNames;
  variant?: "default" | "surface";
  endAddon?: React.ReactNode;
} & React.ComponentPropsWithoutRef<"input">;

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      label,
      errorMessage,
      classNames,
      variant = "default",
      endAddon,
      required,
      className,
      id,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": ariaInvalid,
      type = "text",
      ...inputProps
    },
    ref,
  ) => {
    const input = (
      <InputContainer.Input
        {...inputProps}
        ref={ref}
        type={type}
        required={required}
        className={twMerge(
          variant === "surface" && FILTER_TEXT_FIELD_INPUT_CLASSNAME,
          classNames?.input,
        )}
      />
    );

    return (
      <InputContainer
        id={id}
        label={variant === "default" ? label : undefined}
        required={required}
        className={className}
        classNames={classNames}
        aria-invalid={ariaInvalid}
        errorMessage={errorMessage}
        aria-describedby={ariaDescribedBy}
        bare={variant === "surface"}
        {...inputProps}
      >
        {variant === "surface" ? (
          <PickerContainer
            label={label}
            className={twMerge(className, classNames?.container)}
          >
            {input}
            {endAddon}
          </PickerContainer>
        ) : (
          input
        )}
      </InputContainer>
    );
  },
);

TextField.displayName = "TextField";

export default TextField;
